import { render, staticRenderFns } from "./doneReadOnly.vue?vue&type=template&id=0c3cc036&scoped=true&"
import script from "./doneReadOnly.vue?vue&type=script&lang=js&"
export * from "./doneReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./doneReadOnly.vue?vue&type=style&index=0&id=0c3cc036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3cc036",
  null
  
)

export default component.exports